import { URLs } from '../../constants/apiEndpoints';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';

// fetch all artiles
export const getAllNotification = async ({ pageParam, email }) => {
  const queryParams = new URLSearchParams({
    page: String(pageParam),
    limit: '6',
  }).toString();
  const res = await PrivateAxiosInstance.get(
    `${URLs.GET_NOTIFICATION}?${queryParams}`,
    email
  );
  return res?.data;
};

// view message
export const viewMessage = async ({ id, userId }) => {
  const res = await PrivateAxiosInstance.put(
    `${URLs.GET_NOTIFICATION}/${id}/read`,
    {
      userId,
    }
  );
};
